var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container max-w-full mx-auto md:py-4 px-6 text-gray-800"})}
var staticRenderFns = []

export { render, staticRenderFns }